import { useQuery } from '@tanstack/react-query';

import { notificationQueries } from '../api/notification';
import useNotificationApiInstance from './useNotificationApiInstance';

interface UseNotificationBadgeOptions {
  enabled?: boolean;
}

/**
 * Notification badge (unseenCount) 훅.
 * @description
 * - GNB bell 진입 시 unseenCount 표시 전용.
 * - 사용자가 종을 클릭하면 useMarkNotificationsSeen 으로 lastSeenAt cursor를 갱신하고 본 query를 invalidate.
 * - SSE NOTIFICATION 이벤트 도착 시 useNotificationWithSSE 에서 invalidate.
 */
const useNotificationBadge = (options: UseNotificationBadgeOptions = {}) => {
  const { enabled = true } = options;
  const { instance, endpoint } = useNotificationApiInstance();

  return useQuery({
    ...notificationQueries.badge(instance),
    enabled: enabled && Boolean(endpoint),
  });
};

export default useNotificationBadge;
